module.exports = __webpack_public_path__ + "static/media/value_prop_img_4.82d77aea.jpg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/value_prop_img_4.jpg
// module id = 1417
// module chunks = 0